import _ from "lodash";
import React from "react";
import classNames from "classnames";
import classes from "./Header.scss";

import I18nHOC from "UIComponents/I18nHOC";
import { Button, PageHeader } from "@toddle-edu/ds-web";
import { TickCircleFilled, ToddleColored } from "@toddle-edu/ds-icons";
import { ToddleIcon } from "SvgComponents";

const Header = props => {
  const {
    onBackClick,
    isDoneDisabled = false,
    showTimer,
    timer,
    isRecordingPaused,
    onDoneClick,
    t,
    title,
    flipCamera,
    showFlipCamera = false,
    isGlobalHeaderEnabled = false,
    isCaptureImage = false,
    rightHeaderButton = null,
    shouldBeResponsive = false,
  } = props;

  const timerContainerClass = classNames({
    [classes.timerContainer]: true,
  });

  const container = classNames({
    [classes.container]: true,
  });

  const pageHeaderChildrenProps = {
    ...(shouldBeResponsive &&
      window.innerWidth <= 820 && {
        width: "33%",
      }),
  };

  const hideButtonContent = shouldBeResponsive && window.innerWidth < 670;

  return (
    <div className={container}>
      {isGlobalHeaderEnabled && !shouldBeResponsive ? (
        <PageHeader dsVersion="2.0" testId="journal-postcreation-header">
          <PageHeader.Left
            onBackClick={onBackClick}
            title={title}
            icon={<ToddleColored size={"small"} />}
          />
          <PageHeader.Middle>
            {showTimer ? (
              <div className={timerContainerClass}>
                {!isRecordingPaused && <div className={classes.redDot}></div>}
                <div
                  className={classes.timerText}
                  style={{ fontSize: isGlobalHeaderEnabled ? "1.4rem" : "" }}
                >
                  {timer}
                </div>
              </div>
            ) : null}
          </PageHeader.Middle>
          <PageHeader.Right>
            {showFlipCamera && !_.isUndefined(flipCamera) ? flipCamera : null}
            {!isCaptureImage ? (
              <Button
                size="medium"
                dsVersion="2.0"
                variant="primary"
                onClick={onDoneClick}
                disabled={isDoneDisabled}
                icon={<TickCircleFilled variant={"on"} size={"xx-small"} />}
                testId="journal-postcreation-done"
              >
                {!hideButtonContent && t("common:add")}
              </Button>
            ) : null}
            {rightHeaderButton ? rightHeaderButton : null}
          </PageHeader.Right>
        </PageHeader>
      ) : (
        <PageHeader testId="journal-postcreation-header">
          <PageHeader.Left
            onBackClick={onBackClick}
            title={title}
            icon={<ToddleIcon />}
            {...pageHeaderChildrenProps}
          />
          <PageHeader.Middle>
            {showTimer ? (
              <div className={timerContainerClass}>
                {!isRecordingPaused && <div className={classes.redDot}></div>}
                <div className={classes.timerText}>{timer}</div>
              </div>
            ) : null}
          </PageHeader.Middle>
          <PageHeader.Right {...pageHeaderChildrenProps}>
            {showFlipCamera && !_.isUndefined(flipCamera) ? flipCamera : null}
            <Button
              size="medium"
              dsVersion="2.0"
              variant="progressive"
              onClick={onDoneClick}
              disabled={isDoneDisabled}
              icon={<TickCircleFilled variant={"on"} size={"xx-small"} />}
              testId="journal-postcreation-done"
              className={classes.doneButton}
            >
              {!hideButtonContent && t("common:done")}
            </Button>
            {rightHeaderButton ? rightHeaderButton : null}
          </PageHeader.Right>
        </PageHeader>
      )}
    </div>
  );
};

export default I18nHOC({ resource: "common" })(Header);
